import { MenuList } from '@reach/menu-button';
import React from 'react';

import './NavigationSubmenuList.scss';

interface Props {
  children: React.ReactNode;
  isExpanded: boolean;
}

export const NavigationSubmenuList: React.FC<Props> = ({ children }) => {
  return <MenuList className="NavigationSubmenuList">{children}</MenuList>;
};
